<template>
  <div id="main">
    <NavigationBar @download="handleDownloadApp" :from="from" :apkUrl="apkUrl"/>
    <SectionBanner @download="handleDownloadApp" :from="from" :apkUrl="apkUrl"/>
    <SectionProduct/>
    <SectionService/>
    <SectionAboutUs/>
    <RightFloatBar/>
    <div class="flex-row app-bg d-none d-lg-block">
      <div><img src="../assets/bg_banner.png" width="100%"/></div>
      <div><img src="../assets/bg_product_left.png" align="left" height="100%" style="margin-top: 400px"/></div>
      <div><img src="../assets/bg_little_rect.png" align="right" style="margin-right: 300px"/></div>
      <div><img src="../assets/bg_little_rect.png" align="left" style="margin-right: 300px"/></div>
    </div>
  </div>
</template>

<script>
  import NavigationBar from "../components/NavigationBar";
  import SectionBanner from "../components/SectionBanner";
  import SectionProduct from "../components/SectionProduct";
  import SectionService from "../components/SectionService";
  import SectionAboutUs from "../components/SectionAboutUs";
  import RightFloatBar from "../components/RightFloatBar";

  export default {
    name: "Main",
    data() {
      return {
        from: "",
        apkUrl: "https://sj.qq.com/myapp/detail.htm?apkName=cn.yimulixin.jiangehui",
      }
    },
    components: {
      NavigationBar,
      SectionBanner,
      SectionProduct,
      SectionService,
      SectionAboutUs,
      RightFloatBar
    },
    methods: {
      handleDownloadApp() {
        // this.$router.push({path: "/app"});
        window.location.href = this.apkUrl;
      }
    },
    mounted() {
      let isiOS = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
      let isAndroid = /(Android)/i.test(navigator.userAgent);
      let isPc = !isiOS && !isAndroid;
      if (!isPc) {
        this.from = this.$route.query['from'];
      }
    }
  };
</script>

<style scoped>
  @media (max-width: 992px) {
    #main {
      background-color: #f9fefc;
    }
  }

  .app-bg {
    background-color: #f9fefc;
    position: absolute;
    top: 0;
    z-index: -100;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Main.vue